import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Auto-recover once from stale-bundle chunk load failures (old tab -> new lazy route)
const isChunkError = (msg) =>
  /Loading chunk|ChunkLoadError|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg || "");
const reloadOnceOnChunkError = () => {
  if (sessionStorage.getItem("chunk-reloaded") !== "1") {
    sessionStorage.setItem("chunk-reloaded", "1");
    window.location.reload();
  }
};
window.addEventListener("error", (e) => {
  if (isChunkError(e.message)) reloadOnceOnChunkError();
});
window.addEventListener("unhandledrejection", (e) => {
  const m = (e.reason && (e.reason.message || String(e.reason))) || "";
  if (isChunkError(m)) reloadOnceOnChunkError();
});
window.addEventListener("load", () => {
  setTimeout(() => sessionStorage.removeItem("chunk-reloaded"), 10000);
});

// Register Service Worker for PWA (offline support + faster repeat loads)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('ServiceWorker registered:', registration.scope);
      })
      .catch((error) => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}
